import { ValetPriceField } from './billing-form-fields.js';
import type { BillingFlags } from './types.js';

interface HardwareModulesSectionProps {
  modules: NonNullable<BillingFlags['hardwareModules']>;
  disabled: boolean;
  onSaveMonthly: (key: 'barrier' | 'printer', cents: number) => void;
  onSaveSetup: (key: 'barrier' | 'printer', cents: number) => void;
}

/** Hardware sold on consult: monthly MRR + one-time install fee (not billed via Asaas). */
export const HardwareModulesSection = ({
  modules,
  disabled,
  onSaveMonthly,
  onSaveSetup,
}: HardwareModulesSectionProps) => (
  <div className="border-t border-border pt-4">
    <p className="mb-2 text-sm font-medium">Hardware — sob consulta</p>
    <p className="mb-3 text-xs text-muted-fg">
      Mensalidade entra no MRR quando o módulo está ativo. A taxa de instalação é cobrada à parte
      (fora do Asaas) e serve de referência para o comercial.
    </p>
    <div className="space-y-4">
      {modules.map((m) => (
        <div key={m.key} className="grid gap-3 rounded-md border border-border p-3 sm:grid-cols-2">
          <div className="sm:col-span-2">
            <p className="text-sm font-medium">{m.label}</p>
            {m.description && <p className="text-xs text-muted-fg">{m.description}</p>}
          </div>
          <ValetPriceField
            label="Mensalidade"
            valueCents={m.monthlyCents}
            disabled={disabled}
            onSave={(cents) => onSaveMonthly(m.key, cents)}
          />
          <ValetPriceField
            label="Taxa de instalação (única)"
            valueCents={m.setupCents}
            disabled={disabled}
            onSave={(cents) => onSaveSetup(m.key, cents)}
          />
        </div>
      ))}
    </div>
  </div>
);
